export const SELECTION_STARTS = 'SELECTION_STARTS'
export const SELECTION_ENDS = 'SELECTION_ENDS'
export const SELECTION_EXPANDS = 'SELECTION_EXPANDS'
export const SET_SELECTION = 'SET_SELECTION'
export const SET_DATA = 'SET_DATA'
export const SET_CONTENT = 'SET_CONTENT'
export const PASTE_DATA = 'PASTE_DATA'
export const SET_EDIT_CONTENT = 'SET_EDIT_CONTENT'
export const START_EDIT = 'START_EDIT'
export const COMMIT_EDIT = 'COMMIT_EDIT'
export const CANCEL_EDIT = 'CANCEL_EDIT'
export const CLEAR_DIRTY = 'CLEAR_DIRTY'
